import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import BaoSearchDialog from "./../../factories/bao-search-dialog";
import BaoMenu from "./../../services/bao-menu";
import SearchPaging from "./../../factories/search-paging";
import TabController from "./../../factories/tab-controller";
import TabPage from "./../../factories/tab-page";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
function ConfigurationItemProjectViewModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.ConfigurationItem = parent;
    self.ProjectTabCollection = ko.observableArray([]);
    self.ProjectTabPageIndex = ko.observable(0);
    self.ProjectTabPageIndex.subscribe(function () {
        self.RefreshProjectGrid();
    });
    self.ProjectTabPageSize = ko.observable(10);
    self.ProjectTabTotalRows = ko.observable(0);
    self.ProjectTabSorting = ko.observableArray();
    self.ProjectTabSorting.subscribe(function () {
        self.RefreshProjectTabGrid();
    });
    self.SelectProjectTabRow = function (item) {
        self.SelectedProjectTabRow(item);
        return true;
    };
    self.SelectedProjectTabRow = ko.observable({});
    self.SelectedProjectTabRow.subscribe(function () { });
    self.RefreshProjectTabGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/GetConfigurationItemProjectCollection", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            configurationItemId: ko.unwrap(self.ConfigurationItem.ConfigurationItemId()),
            pageIndex: self.ProjectTabPageIndex(),
            pageSize: self.ProjectTabPageSize(),
            sorting: self.ProjectTabSorting()
        }), function (searchResult) {
            self.SelectedProjectTabRow(null);
            self.ProjectTabTotalRows(0);
            self.ProjectTabCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.ProjectTabCollection(searchResult.Models);
                self.ProjectTabTotalRows(searchResult.TotalRows);
            }
            tabPage.IsLoading(false);
        });
    };
    self.OpenProjectTab = function (item) {
        window.open("#/project/" + item.ConfigurationItemId);
    };
    self.Refresh = function () {
        self.RefreshProjectTabGrid();
    };
    self.loaded = function () {
        return self.Refresh();
        self.RefreshProjectTabGrid();
    };
}
;
export default ConfigurationItemProjectViewModel;